import React, { useState } from 'react';
import './CategoryPageContent.css';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHeart, faClose } from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from 'react-router-dom';

const CategoryPageContent = () => {
  const [heartStates, setHeartStates] = useState(new Array(9).fill(false));
  const [isFilterVisible, setIsFilterVisible] = useState(false);
  const [activeCategory, setActiveCategory] = useState('Green Plants'); 
  const navigate = useNavigate();

  const toggleHeart = (index) => {
    setHeartStates(prevStates => {
      const newStates = [...prevStates];
      newStates[index] = !newStates[index];
      return newStates;
    });
  };

  const toggleFilter = () => {
    setIsFilterVisible(!isFilterVisible);
  };

  const handleCategoryDetailsClick = () => {
    navigate('/category-details');
  };

  const handleCategoryClick = (category) => {
    setActiveCategory(category); 
  };

  return (
    <div className='position-relative'>
      <div className="filter-hide min-vh-100 light-bg shadow p-3 ps-4" 
        style={{
          left: isFilterVisible ? "0" : "-320px",
          transition: "left 0.3s ease-in-out",
        }}>
        <div className="d-flex justify-content-between">
          <div className="d-flex align-items-center gap-3">
            <h5>Filter</h5>
            <img src="images/lets-icons_filter.png" alt="" />
          </div>
          <FontAwesomeIcon icon={faClose} onClick={toggleFilter} className='btn-danger btn px-2'/>
        </div>
        <h4 className='secondary-color my-3'>Categories</h4>
        {['All', 'Green Plants', 'Flower Plants', 'Cacti', 'Hanging Plants', 'Tree Plants', 'Gifts', 'Subscription', 'Accessories and Pottery'].map(category => (
          <h6 
            key={category} 
            className={`mb-3 p-2 filter-icon ${activeCategory === category ? 'active' : ''}`} 
            onClick={() => handleCategoryClick(category)}
          >
            {category}
          </h6>
        ))}
      </div>
      
      <div className="row">
        <div className="col-lg-2 d-none d-lg-block min-vh-100 light-bg shadow p-3 ps-4">
          <div className="d-flex align-items-center gap-3">
            <h5>Filter</h5>
            <img src="images/lets-icons_filter.png" alt="" />
          </div>
          <h4 className='secondary-color my-3'>Categories</h4>
          {['All', 'Green Plants', 'Flower Plants', 'Cacti', 'Hanging Plants', 'Tree Plants', 'Gifts', 'Subscription', 'Accessories and Pottery'].map(category => (
            <h6 
              key={category} 
              className={`mb-3 p-2 filter-icon ${activeCategory === category ? 'active' : ''}`} 
              onClick={() => handleCategoryClick(category)}
            >
              {category}
            </h6>
          ))}
        </div>

        <div className="col-lg-10 p-3 ps-4">
          <div className="d-flex justify-content-between align-items-center">
            <img src="images/Group 75.png" className='category-title' alt="" />
            <div className="d-flex d-lg-none align-items-center gap-3 price-bg text-white hovers rounded-4 px-3 py-2" onClick={toggleFilter}>
              <h5 className='m-0'>Filter</h5> 
            </div>
          </div>
          <div>
            <select className='border-0 main-bg p-1 rounded-pill text-white mt-3' style={{ outline: "none" }}>
              <option value="Default Sort" selected>Default Sort </option>
              <option value="Undefault Sort">Undefault Sort </option>
            </select>
          </div>
          <div className="row mt-4">
            {Array(9).fill().map((_, index) => (
              <div className="col-lg-4 col-md-6 px-4 mb-4" key={index}>
                <div className="card p-3 rounded-4 h-100 position-relative">
                  <img src="images/flower.png" className="category-img mb-2" alt="" />
                  {heartStates[index] ? (
                    <FontAwesomeIcon
                      icon={faHeart}
                      className="text-danger heart-icon position-absolute"
                      onClick={() => toggleHeart(index)}
                    />
                  ) : (
                    <img
                      src="images/heart-thin.png"
                      className="heart-image position-absolute"
                      alt=""
                      onClick={() => toggleHeart(index)}
                    />
                  )}
                  <div className="d-flex justify-content-between align-items-center mb-2">
                    <h6 className="m-0 hovers" onClick={handleCategoryDetailsClick}>Lorem ipsum</h6>
                    <h4 className="main-color m-0">$100</h4>
                  </div>
                  <p className="mb-2">
                    Lorem Ipsum is simply dummy text of the printing and typesetting
                    industry Lorem Ipsum is simply dummy text of the printing and
                    typesetting industry
                  </p>
                  <div className="d-flex justify-content-end">
                    <img src="images/bi_cart.svg" className="hovers" alt="" />
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CategoryPageContent;
